"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const applyCommand_1 = require("../../applyCommand");
const getState_1 = require("../../helpers/getState");
const evaluateContentForCurriculumUpdation_1 = require("../common/evaluateContentForCurriculumUpdation");
function ExecuteUpdateContentMutationForCurriculum(command, user, content, allParentContents, childContents, states, enrolments, stateInteractions) {
    const events = [];
    const UpdateContentMutationPayload = applyCommand_1.applyCommand(command, user, content, childContents, states, enrolments, stateInteractions);
    events.push(...UpdateContentMutationPayload.events);
    const curriculumState = getState_1.getStateByContentIdUserId(states, command.rootContentId, user.userId);
    if (curriculumState.completionStatus !== 'complete') {
        const EvaluationPayload = evaluateContentForCurriculumUpdation_1.evaluateContentForCurriculumUpdation(command, user, content, allParentContents, UpdateContentMutationPayload.states);
        events.push(...EvaluationPayload.events);
        return {
            events,
            states: EvaluationPayload.states,
            enrolments: UpdateContentMutationPayload.enrolments,
            stateInteractions: UpdateContentMutationPayload.stateInteractions
        };
    }
    else {
        return {
            events,
            states: UpdateContentMutationPayload.states,
            enrolments: UpdateContentMutationPayload.enrolments,
            stateInteractions: UpdateContentMutationPayload.stateInteractions
        };
    }
}
exports.ExecuteUpdateContentMutationForCurriculum = ExecuteUpdateContentMutationForCurriculum;
//# sourceMappingURL=ExecuteUpdateContentMutationForCurriculum.js.map